export default __webpack_public_path__ + "static/martin-48f5fc8f5bd2fa7ee68553e772f8d3c3.png";